<template>
  <div id="content">
    <div class="container space-2">
      <!-- Blog -->
      <article class="row mb-3">
        <div class="col-md-2">
          <img class="card-img" :src="action.image" alt="Image présentée dans l'idée">
        </div>

        <div class="col-md-7">
          <div class="card-body d-flex flex-column h-100 px-0">
            <span class="d-block mb-2 font-weight-bold" :style="`color: ${action.theme.color}`">{{action.theme.title}}</span>
            <h3 class="text-inherit">{{action.title}}</h3>
            <p>{{action.description}}</p>

            <div class="media align-items-center mt-auto">
              <div class="avatar avatar-sm avatar-circle mr-3">
                <img class="avatar-img" :src="action.author.photo" alt="Avatar de l'auteur" style="width: 50px; height: 50px; object-fit: cover;">
              </div>

              <div class="media-body">
                <span class="text-dark">
									<a class="d-inline-block text-inherit font-weight-bold"
                     :href="'/modules/dlnkmeetings/contact' + `?id=${action.id_customer}`">
										{{action.author.name}}
									</a>
                </span>
              </div>

              <div class="media-body d-flex justify-content-end text-muted font-size-1 ml-2">

                <button v-if="action.liked == 1 && customer_id != 0" class="btn btn-sm btn-danger w-100" type="button" @click="dislike(action.id)">
                  <i class="fa fa-thumbs-down fa-lg" aria-hidden="true"></i>
                  &nbsp;Je n'aime plus
                </button>
                <button v-else class="btn btn-sm btn-primary w-100" type="button" @click="like(action.id)">
                  <i class="fa fa-thumbs-up fa-lg" aria-hidden="true"></i>
                  &nbsp;J'aime
                </button>

                <div class="col-3">
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <span v-text="action.total_votes"></span>
                    </div>
                    <div class="col-6 text-left">
                      <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </article>
      <!-- End Blog -->

    </div>
  </div>
</template>

<script>

export default {
  props: {
    'action_id': Number,
  },
  data: function () {
    return {
      action: {
        author: {

        },
        theme: {
          color: "",
          title: "",
        },
      },
      theme: 0,
    }
  },
  mounted() {
    this.get_data();
  },

  methods: {

    get_data: function() {
      this.get_action()
    },

    get_action: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas/${_this.action_id}.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get( api_url)
          .then(function (response) {
            _this.action = response.data.idea
          })
          .catch(function (error) {
            console.log(error);
          })

          .then(function () {
                // always executed
              }
          );
    },

    new_action: function(action) {
      this.action_id = 0;
      this.title = "";
      this.description = "";
      this.theme_id = 0;
      this.method = 'post'

      $('#action_modal').modal('show');
    },

    post_action: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_element = document.getElementById("action_form");
      const form_data = new FormData(form_element);
      form_data.append('image_base64', _this.image)

      axios({
        method: 'post',
        url: api_url,
        data: form_data,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.message = "L'idée a été proposé. Elle est en attente de validation";
            _this.message_type = "alert-success";
            _this.get_data()
            $('#action_modal').modal('hide');
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";

            // _this.message = "Une erreur est survenue.";
            // _this.message_type = "alert-danger";
          });
    },

    toggle_theme: function (id) {
      let allCards = $('.card-action');
      let chosenCards = $(String('.action-theme-' + id));

      if ( id === 0 ) {
        allCards.show();
      } else {
        allCards.hide();
        chosenCards.show();
      }

      $('#sortByTheme').children().removeClass('active');
      $('#sortByTheme').children( '#' + id ).addClass('active');
    },

    sort: function (order_by, order_direction) {
      const _this = this;

      _this.get_actions();
      _this.order_by = order_by;
      _this.order_direction = order_direction;
      $('#dropdown-sort').dropdown('toggle');
    },

    validate_title: function () {
      this.errors.title = false;
      if(this.title.length < 3 || this.title.length > 128) {
        this.errors.title = true;
      }
    },

    validate_description: function () {
      this.errors.description = false;
      if(this.description.length < 3 || this.description.length > 400) {
        this.errors.description = true;
      }
    },

    error: function(message) {
      this.message = message;
      this.message_type = "alert-danger";
    },


    like: async function (id) {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas/${id}/like.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'post',
        url: api_url,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.get_data()
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";
          });
    },

    dislike: async function (id) {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas/${id}/dislike.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'delete',
        url: api_url,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.get_data()
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";

            // _this.message = "Une erreur est survenue.";
            // _this.message_type = "alert-danger";
          });
    },

    search_actions(id) {
      this.get_actions();
    }
  }
}
</script>